import {object, string} from 'yup'
import type { LoginRequest } from '../types/auth'

const authValidationSchema = object<LoginRequest>({
    UserCode: string().required("El nombre de usuario es requerido"),
    password: string().required("La contraseña es requerido")
})

export default authValidationSchema;